import { render, staticRenderFns } from "./AddNewDocModal.vue?vue&type=template&id=fbcae5c6"
import script from "./AddNewDocModal.vue?vue&type=script&lang=js"
export * from "./AddNewDocModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports